import { SVGProps, Ref, forwardRef } from 'react';

export const VideocameraHyperstarFilledSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    d="M11 2c5.105 0 7.314 1.448 7.86 5.574L22.04 6H24v12h-1.96l-3.18-1.574C18.313 20.552 16.104 22 11 22H8c-6 0-8-2-8-8v-4q-.001-1.168.106-2.142c.725.642 1.4 1.396 1.896 2.14L3.5 12.245l1.498-2.247a11.5 11.5 0 0 1 3-3L10.245 5.5 7.998 4.002C7.254 3.506 6.5 2.83 5.858 2.106Q6.832 2 8 2z"
                    fill="currentColor"
                />
                <path
                    d="M3.5 2A13.3 13.3 0 0 0 7 5.5 13.3 13.3 0 0 0 3.5 9 13.3 13.3 0 0 0 0 5.5 13.3 13.3 0 0 0 3.5 2"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
VideocameraHyperstarFilledSize24Glyph.displayName = 'VideocameraHyperstarFilledSize24Glyph';
